import { allEachConditionDataErrorAtom } from "atoms/Rtool/cabinAtoms";
import { Config } from "atoms/Rtool/newConfigAtoms";
import { useAtomValue } from "jotai";

type Status = 'notstarted' | 'success' | 'error' | 'loading';
export type WithStatus = { data: Record<string, Array<any>>, status: Status };

/** Record<string, T> を受け取る汎用関数 */
export function useIsAllNoiseError(): boolean {
    return useAtomValue(allEachConditionDataErrorAtom);
};

/** Record<string, T> を受け取る汎用関数 */
export function allStatusError<T extends WithStatus>(
    dict: Record<string, T>
): boolean {
    return Object.values(dict).every(item => item.status === 'error');
};

/** Record<string, T> を受け取る汎用関数 */
export function allNullData<T extends WithStatus>(
    dict: Record<string, T>
): boolean {
    const values = Object.values(dict);
    const allNullCabinNoiseTarget = Object.values(values).every(arr => arr.data["cabin_noise_target"].length === 0)
    const allNullCabinNoisePred = Object.values(values).every(arr => arr.data["cabin_noise_pred"].length === 0)
    return allNullCabinNoiseTarget && allNullCabinNoisePred;
}

/**　configAtom の全フィールドが truthy かどうかを判定する　*/
export const isConfigComplete = (config: Config): boolean => {
    return Boolean(
        config.project_id &&
        config.destination_id &&
        config.lot_id &&
        config.phase_id &&
        config.unit_id &&
        config.calculation_id
    );
};

export function areConfigsEqual(a: Config, b: Config): boolean {
    return (
        a.project_id === b.project_id &&
        a.destination_id === b.destination_id &&
        a.lot_id === b.lot_id &&
        a.phase_id === b.phase_id &&
        a.unit_id === b.unit_id &&
        a.calculation_id === b.calculation_id &&
        a.condition_id === b.condition_id &&
        a.graph_id === b.graph_id
    );
};
